import { partners } from "../mock";
import { Handshake } from "lucide-react";

export default function Partners() {
  return (
    <section className="dark-green-section py-14 border-t border-white/5">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <p className="text-center text-slate-300 text-sm md:text-base mb-8 flex items-center justify-center gap-2">
          <Handshake className="w-4 h-4 text-emerald-400" />
          Parceria estratégica com as maiores distribuidoras de energia
        </p>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3 md:gap-5">
          {partners.map((p) => (
            <div
              key={p.name}
              className="rounded-xl border border-white/10 bg-white/[0.03] px-4 py-5 text-center hover:border-emerald-400/40 hover:bg-white/[0.06] transition-colors"
            >
              <div className="text-white font-bold text-base md:text-lg">{p.name}</div>
              <div className="text-emerald-400/80 text-xs mt-1">{p.detail}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
